// Deterministic clock-time formatter for a single flight sample point.
//
// Extracted to its own module so the main thread (app.ts) and the analysis Web
// Worker (src/analysis/run-raw-analysis.ts) share one implementation. The valve
// detector formats window start/end clock times through this, so any drift
// between two copies would make the worker-computed bundle differ from the
// synchronous one. Keeping a single source of truth guarantees identical notes.

interface FlightPointTime {
  displayTime?: string | null;
  timestamp?: string | number | Date | null;
}

export function formatPointTime(point: FlightPointTime | null | undefined): string {
  if (point?.displayTime) return point.displayTime;
  if (!point?.timestamp) return "--";
  return new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    timeZone: "America/Phoenix",
  }).format(new Date(point.timestamp));
}
